import React, { useState } from 'react'
import { websiteConfigApi } from '../services/api'
import { useToast } from '../contexts/ToastContext'
import { Input } from '../components/common/Input'

function CouponTrigger() {
  const [couponCode, setCouponCode] = useState('')
  const [loading, setLoading] = useState(false)
  const { showSuccess, showError } = useToast()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!couponCode.trim()) {
      showError('请输入优惠券码')
      return
    }

    setLoading(true)
    try {
      // 保持与后端接口一致，虽然隐藏了其他字段，但传递默认值或空值
      const response = await websiteConfigApi.triggerConversionByCoupon({
        couponCode: couponCode.trim(),
        senderName: '未知用户',
        phone: ''
      })
      if (response.success || response) {
        showSuccess('提交成功')
        setCouponCode('')
      } else {
        showError(response.message || '提交失败')
      }
    } catch (error) {
      console.error('Trigger error:', error)
      showError(error.response?.data?.message || '提交时发生错误')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 space-y-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900">优惠券转化触发</h1>
          <p className="text-sm text-gray-500 mt-2">请输入优惠券码以触发转化事件</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="优惠券码"
            name="couponCode"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            placeholder="请输入优惠券码"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 px-4 bg-indigo-600 text-white font-medium rounded-xl shadow-lg transition duration-200 
              ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-indigo-700 active:scale-95'}`}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                正在提交...
              </div>
            ) : '立即提交'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default CouponTrigger
